import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=e854d122&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=e854d122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e854d122",
  null
  
)

export default component.exports